import { ofType } from "redux-observable";
import { filter, mapTo } from "rxjs/operators";
import { IdOutskirtBuildings } from "../../../constants/IdOutskirtBuildings";
import { TypeActionImprovement } from "../../improvement/actionImprovement";
import { actionContractInfoRequest } from "../actionContractInfo";
import { IdMarketImprovement } from "../IdMarketImprovement";
export var epicContractInfoRequestImprovementUnlock = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionImprovement.BuyRequest), filter(function (action) {
        return action.id === IdMarketImprovement.ContractSlotBonus &&
            action.buildingId === IdOutskirtBuildings.Market;
    }), mapTo(actionContractInfoRequest()));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractInfoRequestImprovementUnlock.ts
// module id = 1996
// module chunks = 3